import {SubTitle} from "../../Components/Text";
import styled from "styled-components";
import React, { useEffect } from "react";
import {useNavigate} from "react-router-dom";
import {ScaleLoader} from "react-spinners";

const GoogleCallbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;


function GoogleCallback() {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/settings?googleAuth=success');
        }, 2000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
      <GoogleCallbackWrapper>
        <LoadingContainer>
          <SubTitle>Processing</SubTitle>
          <ScaleLoader color="#B8FE01" height={70} width={10} />
        </LoadingContainer>
      </GoogleCallbackWrapper>
    );
  }

  export default GoogleCallback;